'use client';

import React from 'react';
import { Badge, Group, Tooltip } from '@mantine/core';
import { IconWifi, IconWifiOff } from '@tabler/icons-react';
import useSafeTranslation from '@/hooks/useSafeTranslation';

// Placeholder: always online, no sync logic
export function ConnectivityIndicator() {
  const { tSafe: t } = useSafeTranslation();
  const online = true;

  return (
    <Group gap="xs" align="center">
      {/* Desktop: icon + text, Mobile: icon only */}
      <Tooltip
        label={online ? (t('status.online') ?? 'Online') : (t('status.offline') ?? 'Offline')}
      >
        <Badge
          color={online ? 'teal' : 'red'}
          variant="light"
          leftSection={online ? <IconWifi size={16} /> : <IconWifiOff size={16} />}
          className="connectivity-badge"
        >
          <span className="connectivity-text">
            {online ? (t('status.online') ?? 'Online') : (t('status.offline') ?? 'Offline')}
          </span>
        </Badge>
      </Tooltip>
    </Group>
  );
}

export default ConnectivityIndicator;
